import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function GoogleCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleCallback = async () => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const state = params.get('state');

    console.log('GoogleCallback - code:', code, 'state:', state);

    if (!code || !state) {
      console.error('Missing code or state');
      toast.error('Error en la autorización');
      navigate('/dashboard');
      return;
    }

    try {
      const url = `${BACKEND_URL}/api/google/callback?code=${encodeURIComponent(code)}&state=${encodeURIComponent(state)}`;
      console.log('Calling:', url);
      
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include'
      });

      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);

      if (response.ok && data.success) {
        // Iniciar temporizador de 5 minutos para servicios de Google
        const now = Date.now();
        localStorage.setItem('google_service_timer', now.toString());
        
        toast.success('Google conectado exitosamente. Servicios listos en 5 minutos.');
        
        // Recargar página para actualizar estado (admin verá el timer en dashboard)
        setTimeout(() => {
          window.location.href = '/dashboard';
        }, 1500);
      } else {
        console.error('Callback failed:', data);
        toast.error('Error al conectar Google');
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error:', error);
      toast.error('Error al procesar callback');
      navigate('/dashboard');
    }
  };

  useEffect(() => {
    handleCallback();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-black flex items-center justify-center">
      <div className="text-center space-y-4">
        <img 
          src="/kompa-logo.png" 
          alt="Kompa" 
          className="h-20 w-auto mx-auto mb-4 animate-pulse"
        />
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-yellow-500 mx-auto"></div>
        <p className="text-yellow-500 font-semibold text-lg">Procesando autorización...</p>
        <p className="text-gray-400 text-sm">Conectando con Google</p>
      </div>
    </div>
  );
}